module.exports = "https://r.zoocdn.com/_next/static/images/local-market-stats-journey-line-15e2842fbd191ed5546bb14f7bf13c84.svg";